import type { StandingRow } from "../../data/standings";

type StandingsTableProps = {
    title: string;
    rows: StandingRow[];
    note?: string;
};

export default function StandingsTable({
                                           title,
                                           rows,
                                           note,
                                       }: StandingsTableProps) {
    return (
        <div className="overflow-hidden rounded-3xl border border-white/10 bg-[#0b1220] shadow-[0_20px_60px_rgba(0,0,0,0.25)]">
        <div className="border-b border-white/10 px-4 py-4 md:px-6">
        <h3 className="text-lg font-black uppercase tracking-wide text-white md:text-xl">
            {title}
            </h3>
            </div>

            <div className="overflow-x-auto">
    <div className="min-w-[760px]">
    <div className="grid grid-cols-[56px_minmax(220px,1fr)_64px_64px_64px_64px_64px_64px_80px_72px] items-center border-b border-white/10 bg-white/[0.03] px-4 py-3 text-xs font-black uppercase tracking-wide text-white/60 md:px-6">
        <div>#</div>
    <div>Club</div>
    <div className="text-center">MJ</div>
        <div className="text-center">G</div>
        <div className="text-center">N</div>
        <div className="text-center">D</div>
        <div className="text-center">BP</div>
        <div className="text-center">BC</div>
        <div className="text-center">Diff</div>
        <div className="text-center">Pts</div>
        </div>

    {rows.map((team) => (
        <div
            key={`${title}-${team.rank}-${team.team}`}
        className="grid grid-cols-[56px_minmax(220px,1fr)_64px_64px_64px_64px_64px_64px_80px_72px] items-center border-b border-white/10 px-4 py-4 text-sm text-white last:border-b-0 md:px-6"
        >
        <div className="text-lg font-black text-[#e5ff00]">
            {team.rank}
            </div>

            <div className="min-w-0">
    <div className="flex items-center gap-3 min-w-0">
    <div className="flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-full border border-white/10 bg-white/5 p-1">
    <img
        src={team.logo}
        alt={team.team}
        className="h-full w-full object-contain"
            />
            </div>

            <span className="truncate text-sm font-bold text-white md:text-base">
        {team.team}
        </span>
        </div>
        </div>

        <div className="text-center font-bold">{team.played}</div>
        <div className="text-center font-bold">{team.wins}</div>
        <div className="text-center font-bold">{team.draws}</div>
        <div className="text-center font-bold">{team.losses}</div>
        <div className="text-center font-bold">{team.goalsFor}</div>
        <div className="text-center font-bold">{team.goalsAgainst}</div>
        <div className="text-center font-bold">
        {team.goalDiff > 0 ? `+${team.goalDiff}` : team.goalDiff}
        </div>
        <div className="text-center text-base font-black text-[#ff7a00]">
        {team.points}
        </div>
        </div>
    ))}
    </div>
    </div>

    {note ? (
        <div className="border-t border-white/10 bg-white/[0.02] px-4 py-4 text-sm leading-6 text-white/70 md:px-6">
            {note}
            </div>
    ) : null}
    </div>
);
}